import { inject, Injectable } from '@angular/core';
import { TariffPassApiFrom } from '@api-gen/models/tariff-pass-api-from';
import { TariffTicketApiFrom } from '@api-gen/models/tariff-ticket-api-from';
import { ErrorResponse } from '@api/models';
import { StartWithUnit } from '@core/operators/start-with-unit';
import { RxState } from '@rx-angular/state';
import { RxActionFactory, RxActions } from '@rx-angular/state/actions';
import { TariffsApiService } from '@shared/services/tariffs-api.service';
import { Observable } from 'rxjs';


export interface IProductsState {
    loading: Record<StartWithUnit, boolean>;
    errors: Record<StartWithUnit, ErrorResponse>;
    passesData: TariffPassApiFrom;
    ticketsData: TariffTicketApiFrom;
}

export interface IProductsAction {
    requestPassesData: TariffPassApiFrom;
    requestTicketsData: TariffTicketApiFrom;
}

@Injectable()
export class ProductsState extends RxState<IProductsState> {
    readonly #tariffsApiService: TariffsApiService = inject(TariffsApiService);

    public readonly loading$: Observable<Record<StartWithUnit, boolean>> = this.select('loading');
    public readonly errors$: Observable<Record<StartWithUnit, ErrorResponse>> = this.select('errors');
    public readonly passesData$: Observable<TariffPassApiFrom> = this.select('passesData');
    public readonly ticketsData$: Observable<TariffTicketApiFrom> = this.select('ticketsData');

    readonly #actions: RxActions<IProductsAction> = new RxActionFactory<IProductsAction>().create();

    constructor() {
        super();

        this.setDefaultState();
        this.connectSelectors();
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
            errors: null,
            passesData: null,
            ticketsData: null,
        });
    }

    public requestPassesData(): void {
        this.hold(this.#tariffsApiService.loadTariffPasses(), this.#actions.requestPassesData);
    }

    public requestTicketsData(): void {
        this.hold(this.#tariffsApiService.loadTariffTickets(), this.#actions.requestTicketsData);
    }

    private connectSelectors(): void {
        this.connect('passesData', this.#actions.requestPassesData$);
        this.connect('ticketsData', this.#actions.requestTicketsData$);
    }
}
